import angular from 'angular';
import AppMenu from './app-menu';

const studioMenu = 'studioMenu';
export default studioMenu;

angular.module(studioMenu, [])
    .factory('AppMenu', AppMenu);

